module.exports = __webpack_public_path__ + "img/sneaker-legacy.29887ab5.png";